var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWebNewRemovebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.98 65.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m90.41,31.05l-2.58,4.92c-2.84-1.54-5.46-2.37-7.43-2.37-1.35,0-2.31.53-2.31,1.62,0,3.25,12.4,1.67,12.36,9.93,0,4.87-4.24,7.55-9.91,7.55-3.93,0-7.73-1.14-10.57-3.34l2.4-4.83c2.66,1.89,5.72,2.94,8.34,2.94,1.49,0,2.58-.53,2.58-1.62,0-3.47-12.19-1.67-12.14-9.97,0-4.87,4.11-7.51,9.57-7.51,3.4,0,6.81.96,9.69,2.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m102.46,45.94v6.45h-7.56V19.81h7.56v17.21l7.77-8.3h8.56l-8.65,9.09,8.91,14.58h-8.95l-5.11-9.13-2.53,2.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m129.98,19.81h-7.56v32.58h7.56V19.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m157.07,36.94v15.46h-7.38v-2.72c-1.53,2.02-4.02,3.08-7.21,3.08-5.02,0-8.08-3.08-8.08-7.42s3.19-7.11,9.04-7.16h6.2v-.35c0-2.33-1.53-3.73-4.59-3.73-1.97,0-4.54.7-7.03,1.98l-2.14-5.01c3.67-1.71,6.99-2.68,10.92-2.68,6.47,0,10.22,3.21,10.26,8.57Zm-7.43,7.42v-2.11h-4.76c-2.27,0-3.41.79-3.41,2.55s1.22,2.81,3.32,2.81c2.36,0,4.37-1.32,4.85-3.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m186.16,52.39h-7.56v-3.12c-1.66,2.2-4.06,3.43-7.08,3.43-6.64,0-11.01-4.92-11.01-12.25s4.32-12.03,10.83-12.03c3.1,0,5.59,1.23,7.25,3.43v-12.03h7.56v32.58Zm-7.56-11.77c0-3.64-2.1-6.15-5.24-6.15s-5.24,2.5-5.28,6.15c.04,3.64,2.14,6.19,5.28,6.19s5.24-2.55,5.24-6.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m242.99,37.46v14.93h-7.51v-12.82c0-2.77-1.62-4.48-4.15-4.48-2.75,0-4.5,1.98-4.8,4.79v12.51h-7.56v-23.67h7.56v3.86c1.66-2.77,4.37-4.17,7.86-4.22,5.2,0,8.6,3.56,8.6,9.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e72d61",
    strokeWidth: "0px",
    d: "m252.84,46.03h-6.33v6.36h6.33v-6.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#001726",
    strokeWidth: "0px",
    d: "m206.38,28.88v6.31c1.67,1.2,2.76,3.16,2.76,5.39,0,3.65-2.95,6.62-6.58,6.62s-6.58-2.96-6.58-6.62c0-2.31,1.18-4.35,2.97-5.53v-6.22c-5.41,1.47-9.37,6.17-9.37,11.75,0,6.76,5.81,12.23,12.98,12.23s12.98-5.48,12.98-12.23c0-5.5-3.85-10.15-9.15-11.69Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e72d61",
    strokeWidth: "0px",
    d: "m205.82,28.08h-6.33v6.36h6.33v-6.36Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e72d61",
    stroke: "#e72d61",
    strokeMiterlimit: 10,
    d: "m40.76,38.98v13.15h-6.66v-12.12c0-3.71-1.67-5.42-4.35-5.42-2.99,0-5.08,1.92-5.08,6.02v11.53h-6.66v-12.12c0-3.71-1.58-5.42-4.35-5.42-2.95,0-5.04,1.92-5.04,6.02v11.53H1.95v-22.97h6.36v2.65c1.71-1.96,4.27-2.99,7.22-2.99,3.2,0,5.93,1.24,7.56,3.76,1.84-2.35,4.82-3.76,8.28-3.76,5.46,0,9.39,3.16,9.39,10.16Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e72d61",
    stroke: "#e72d61",
    strokeMiterlimit: 10,
    d: "m69.11,29.16l-10.37,24.38c-2.22,5.55-5.38,7.21-9.52,7.21-2.35,0-4.91-.77-6.4-2.09l2.43-4.74c1.02.9,2.43,1.45,3.76,1.45,1.84,0,2.86-.81,3.76-2.86l.08-.21-9.95-23.14h6.87l6.45,15.58,6.49-15.58h6.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWebNewRemovebg);
export default __webpack_public_path__ + "static/media/logo-web-new-removebg.cfb6c6b84e63912dea7384d94c7fb05b.svg";
export { ForwardRef as ReactComponent };